
const state = {
  sideNavItems: [
  
    {
      isNav: true,
      title: 'Dashboard',
      slug: 'dashboard',
      icon: 'create-dashboard', 
      path: '/',
      module: 'dashboard',
      children: [],
    },
    {
      isNav: false,
      title: 'GENERAL',
      listModule: ['RoleManagement', 'View Users', 'View All Targets', 'View All Facilities']
    },
    // {
    //   isNav: true,
    //   title: 'Reports',
    //   slug: 'Reports',
    //   icon: 'graph-bar',
    //   listModule: [],
    //   children: [
    //     {
    //       title: 'Reports (Annual)',
    //       slug: 'reports-annual',
    //       path: '/reports-annual',
    //       module: ''
    //     },
    //     {
    //       title: 'FHSIS Q1 Reports',
    //       slug: 'fhsis-q1-reports',
    //       path: '/fhsis-q1-reports',
    //       module: ''
    //     },
    //   ],
    // },
    {
      isNav: true,
      title: 'Admin User Management',
      slug: 'admin-user-management',
      icon: 'user-square', 
      path: '/admin-user-management',
      module: 'View Users',
      children: [],
    },
    {
      isNav: true,
      title: 'Role Management',
      slug: 'role-management',
      icon: 'shield-check', 
      path: '/role-management',
      module: 'View Roles',
      children: [],
    },
    // {
    //   isNav: true,
    //   title: 'Facilities',
    //   slug: 'facilities',
    //   icon: 'building',
    //   listModule: ['View All RHU', 'View All BHS'],
    //   children: [
    //     {
    //       title: 'Center Health Development',
    //       slug: 'center-health-development',
    //       path: '/center-health-development',
    //       module: ''
    //     },
    //     {
    //       title: 'Provincial Health Office / MOH',
    //       slug: 'provincial-health-office',
    //       path: '/provincial-health-office',
    //       module: ''
    //     },
    //     {
    //       title: 'City Health Office / MHO',
    //       slug: 'city-health-office',
    //       path: '/city-health-office',
    //       module: ''
    //     },
    //     {
    //       title: 'Rural Health Unit',
    //       slug: 'rural-health-unit',
    //       path: '/rural-health-unit',
    //       module: 'View All RHU'
    //     },
    //     {
    //       title: 'Barangay Health Station',
    //       slug: 'barangay-health-station',
    //       path: '/barangay-health-station',
    //       module: 'View All BHS'
    //     },
    //   ],
    // },
    {
      isNav: true,
      title: 'Organization',
      slug: 'facilities',
      icon: 'building', 
      path: '/facilities',
      module: 'View All Organizations',
      children: [],
    },
    {
      isNav: true,
      title: 'Target Management',
      slug: 'target-management',
      icon: 'focus-target', 
      path: '/target-management',
      module: 'View All Targets',
      children: [],
    },
    {
      isNav: false,
      title: 'REFERENCE DATA',
      listModule: ['View Regions', 'View Provinces', 'View Cities', 'View Barangays', 'View All TCL']
    },
    {
      isNav: true,
      title: 'PSGC',
      slug: 'psgc',
      icon: 'location-pin-alt', 
      listModule: ['View Regions', 'View Provinces', 'View Cities', 'View Barangays'],
      children: [
        {
          title: 'Region',
          slug: 'region',
          path: '/region',
          module: 'View Regions',
        },
        {
          title: 'Province',
          slug: 'province',
          path: '/province',
          module: 'View Provinces',
        },
        {
          title: 'City',
          slug: 'city',
          path: '/city',
          module: 'View Cities',
        },
        {
          title: 'Barangay',
          slug: 'barangay',
          path: '/barangay',
          module: 'View Barangays',
        }
      ]
    },
    {
      isNav: true,
      title: 'Vaccines',
      slug: 'vaccines',
      icon: 'medical-drip', 
      path: '/vaccines',
      module: 'View Vaccines',
      children: [],
    },
    {
      isNav: true,
      title: 'Antigens',
      slug: 'antigens',
      icon: 'medkit', 
      path: '/antigens',
      module: 'View Antigens',
      children: [],
    },
    {
      isNav: true,
      title: 'TCL Structure',
      slug: 'tcl',
      icon: 'bars', 
      path: '/tcl',
      module: 'View All TCL',
      children: [],
    },
  ],
};

// Mutations to update the state
const mutations = {
  SET_SIDE_NAV_ITEMS(state, items) {
    state.sideNavItems = items;
  },
};

// Actions to perform asynchronous operations
const actions = {
  updateSideNavItems({ commit }, items) {
    commit('SET_SIDE_NAV_ITEMS', items);
  },
};

// Getters to access the state
const getters = {
  sideNavItems: (state) => state.sideNavItems,
};

export default {
  state,
  mutations,
  actions,
  getters,
};

